import { intersection } from "lodash";

import { Iterable, IPlace } from "types";
import { TAGS_WITHOUT_TIMETABLE } from "constants/constants";

export const passTimetableCheck = (item: Iterable<IPlace>) => {
  const included = intersection(item.tags, TAGS_WITHOUT_TIMETABLE);
  return included.length > 0;
};
